import { pumaAPI } from "./api"
import {
    BookmarkGridTileDTO,
    GridDTO,
    GridTileDTO,
    ShortcutGridTileDTO,
    WelcomePageContentGridTileDTO,
    WorkspaceContentGridTileDTO,
} from "./models/dto/grid"
import {
    IGridTile,
    IBookmarkGridTile,
    IGrid,
    IShortcutGridTile,
    IWelcomePageContentGridTile,
    IWorkspaceContentGridTile,
} from "../models"

const baseUrl = "Grids/"

export const isBookmarkGridTile = (
    tile: GridTileDTO,
): tile is BookmarkGridTileDTO => {
    return (
        tile.Type === "BookmarkGridTile" &&
        (tile as BookmarkGridTileDTO).BookmarkId !== undefined
    )
}

export const isShortcutGridTile = (
    tile: GridTileDTO,
): tile is ShortcutGridTileDTO => {
    return (
        tile.Type === "ShortcutGridTile" &&
        (tile as ShortcutGridTileDTO).ShortcutId !== undefined
    )
}

export const isWorkspaceContentGridTile = (
    tile: GridTileDTO,
): tile is WorkspaceContentGridTileDTO =>
    tile.Type === "WorkspaceContentGridTile"

export const isWelcomePageContentGridTile = (
    tile: GridTileDTO,
): tile is WelcomePageContentGridTileDTO =>
    tile.Type === "WelcomePageContentGridTile"

export const getDashboardCoverPageGrid = (
    filter: (tile: GridTileDTO) => boolean,
): Promise<IGrid> =>
    pumaAPI
        .postJSON(`${baseUrl}DashboardCoverPage/GetOrCreate`)
        .then(
            (grid: GridDTO): Promise<IGrid> => parseGridResponse(grid, filter),
        )

export const getWorkspaceCoverPageGrid = (
    workspaceId: number,
    filter: (tile: GridTileDTO) => boolean,
): Promise<IGrid> =>
    pumaAPI
        .postJSON(
            `${baseUrl}WorkspaceCoverPage/GetOrCreate?workspaceId=${workspaceId}`,
        )
        .then(
            (grid: GridDTO): Promise<IGrid> => parseGridResponse(grid, filter),
        )

export const getWelcomePageGrid = (
    filter: (tile: GridTileDTO) => boolean,
): Promise<IGrid> =>
    pumaAPI
        .postJSON(`${baseUrl}WelcomePage/GetOrCreate`)
        .then(
            (grid: GridDTO): Promise<IGrid> => parseGridResponse(grid, filter),
        )

export const updateTilesOrder = (
    gridId: number,
    tileIds: number[],
    filter: (tile: GridTileDTO) => boolean,
): Promise<IGrid> =>
    pumaAPI
        .postJSON(`${baseUrl}UpdateTilesOrder`, {
            GridId: gridId,
            TileIds: tileIds,
        })
        .then(
            (grid: GridDTO): Promise<IGrid> => parseGridResponse(grid, filter),
        )

const parseGridResponse = (
    grid: GridDTO,
    filter: (tile: GridTileDTO) => boolean,
): Promise<IGrid> => {
    let tiles: IGridTile[] = []
    tiles = grid.Tiles.$values.filter(filter).map(convertTileDTO)

    return new Promise<IGrid>((resolve) =>
        resolve({ id: grid.GridId, tiles } as IGrid),
    )
}

const convertTileDTO = (tile: GridTileDTO): IGridTile => {
    if (isBookmarkGridTile(tile)) {
        return {
            id: tile.TileId,
            bookmarkId: tile.BookmarkId,
            type: "Bookmark",
        } as IBookmarkGridTile
    } else if (isShortcutGridTile(tile)) {
        return {
            id: tile.TileId,
            shortcutId: tile.ShortcutId,
            type: "Shortcut",
        } as IShortcutGridTile
    } else if (isWelcomePageContentGridTile(tile)) {
        return {
            id: tile.TileId,
            type: "WelcomePageContent",
        } as IWelcomePageContentGridTile
    }
    return {
        id: tile.TileId,
        type: "WorkspaceContent",
    } as IWorkspaceContentGridTile
}
